<template>
    <div>
        <ul class="nav">
            <li class="nav-item" v-for="(step, s) in steps">
                <span class="button d-flex align-items-center justify-content-center" :class="s >= currentStep ? 'button-default' : 'button-primary'">{{ step }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "Navigation",
    data() {
        return {
            steps: [1,2,3,4,5]
        }
    },
    computed: {
        ...mapState('orders', ['currentStep']),
    }
}
</script>

<style lang="scss" scoped>
    .nav {
        padding: 15px 0 30px 0;
        justify-content: space-between;
        position: relative;
        z-index: 4;

        @media (min-width: 768px) {
            max-width: 750px;
            margin: 54px auto 100px;
        }

        &:before {
            content: '';
            position: absolute;
            height: 1px;
            background: $border-color;
            left: 0;
            width: 100%;
            transform: translateY(12px);

            @media (min-width: 768px) {
                transform: translateY(25px);
            }
        }
    }

    .nav-item {
        position: relative;
        z-index: 10;
        border-right: 10px solid white;
        border-left: 10px solid white;
    
        &:first-child {
            border-left: 0;

            .btn-primary {
                &:before {
                    display: none;
                }
            }
        }
    
        &:last-child {
            border-right: 0;
        }
    }

    .button {
        display: inline-block;
        padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
        font-family: var(--bs-btn-font-family);
        font-size: var(--bs-btn-font-size);
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        border: 1px solid red;
        border-radius: var(--bs-btn-border-radius);
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

        font-family: $font-family-base;
        font-size: 16px;
        line-height: 1;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        padding: 0;
        border-color: $border-color;
        color: $medium-gray;
        background: white;

        @media (min-width: 768px) {
            width: 50px;
            height: 50px;
        }
    
    }

    .button-primary {
        @include gradient-primary;
        color: white;
        border-color: rgba(0,0,0,0);

    }
</style>